import { schema } from 'normalizr';
import { SCHEMA_TYPE_NOTIFICATION_TYPES } from '../constants/schemaTypes';

import userSchema from './user';
import orgSchema from './org';

const notificationTypeSchema = new schema.Entity(SCHEMA_TYPE_NOTIFICATION_TYPES);

notificationTypeSchema.define({
  owner: userSchema,
  org: orgSchema,
});

export default notificationTypeSchema;
